import { loadState, saveState } from '../localStorage'
import { hosts } from './hosts'

const initialExampleMap = { 'rules': [[]], 'questions': [] }

export default class StandaloneAdapter {
  async load () {
    let state = loadState()
    if (typeof state === 'undefined') {
      state = initialExampleMap
    }
    return state
  }

  async save (state) {
    saveState(state)
  }

  async getCustomerIdentifier () {
    return 'website'
  }

  getHost () {
    return hosts.STANDALONE
  }

  async loadInitialExampleMap () {
    return initialExampleMap
  }
}
